/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Referral_CtaInputs */

const tr_landing_referral_cta = /** @type {(inputs: Landing_Referral_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemen Başlayın, Ücretsiz Deneyin`)
};

const en_landing_referral_cta = /** @type {(inputs: Landing_Referral_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Now, Try It Free`)
};

const de_landing_referral_cta = /** @type {(inputs: Landing_Referral_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt starten, kostenlos testen`)
};

const ru_landing_referral_cta = /** @type {(inputs: Landing_Referral_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начните сейчас, попробуйте бесплатно`)
};

/**
* | output |
* | --- |
* | "Start Now, Try It Free" |
*
* @param {Landing_Referral_CtaInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_referral_cta = /** @type {((inputs?: Landing_Referral_CtaInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Referral_CtaInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_referral_cta(inputs)
	if (locale === "de") return de_landing_referral_cta(inputs)
	if (locale === "ru") return ru_landing_referral_cta(inputs)
	return tr_landing_referral_cta(inputs)
});